"use client";

import { useTransition } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { EmojiSelect, Select } from "@/components/ui";
import { useIsWindows } from "@/hooks";
import {
  getPublisherGameTypeSelectOptions,
  type PublisherGameType,
} from "../config/gameTypes";
import { createSearchParamsUpdater } from "../utils/updateSearchParams";

interface PublisherGameWishlistFiltersProps {
  type: PublisherGameType;
}

export function PublisherGameWishlistFilters({
  type,
}: PublisherGameWishlistFiltersProps) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();
  const isWindows = useIsWindows();
  const updateParams = createSearchParamsUpdater(searchParams, pathname);

  const handleTypeChange = (nextType: string) => {
    const url = updateParams.update(
      "type",
      nextType === "all" ? null : nextType
    );
    startTransition(() => {
      router.push(url);
    });
  };

  return (
    <div className="inline-flex items-center rounded-md border border-[#2a475e] bg-[#16202d] shadow-sm overflow-visible h-10 transition-all hover:border-[#3a556e]">
      {/* Type Select */}
      <div className="flex items-center gap-3 px-3 sm:px-4 py-2">
        <span className="hidden sm:inline text-xs sm:text-sm text-[#8f98a0] whitespace-nowrap leading-none">
          Type
        </span>
        <div className="flex-1 min-w-0 relative group">
          <div className="absolute inset-0 rounded -mx-1 bg-[#1f2e3f]/0 group-hover:bg-[#1f2e3f]/50 transition-colors pointer-events-none" />
          {isWindows ? (
            <EmojiSelect
              value={type}
              onChange={handleTypeChange}
              options={getPublisherGameTypeSelectOptions()}
              isLoading={isPending}
              className="relative z-10 !h-full text-xs min-w-[140px] sm:text-sm sm:min-w-[180px] !border-0 !bg-transparent !rounded-none !py-0 focus:!ring-0 cursor-pointer leading-none"
              ariaLabel="Game Type"
            />
          ) : (
            <Select
              value={type}
              onChange={handleTypeChange}
              options={getPublisherGameTypeSelectOptions()}
              isLoading={isPending}
              className="relative z-10 h-full text-xs min-w-[140px] sm:text-sm sm:min-w-[180px] !border-0 !bg-transparent !rounded-none !py-0 focus:!ring-0 cursor-pointer leading-none"
              ariaLabel="Game Type"
            />
          )}
        </div>
      </div>
    </div>
  );
}

